import rill from "rill";
import List from "./list";
import Edit from "./edit";
import View from "./view";

const Custom = (app) => {
  app
    .get(
      "/custom",
      async ({
        res,
        locals: {
          query: { athlete, organizationCoach },
        },
      }) => {
        const url = organizationCoach
          ? `/athlete-portal/metrics/custom/list?athlete=${athlete}&organizationCoach=${organizationCoach}`
          : `/athlete-portal/metrics/custom/list?athlete=${athlete}`;
        res.redirect(url);
      }
    )
    .at("/custom/*", rill().setup(List).setup(Edit).setup(View));
};

export default Custom;
